module.exports = __webpack_public_path__ + "static/img/22.5f2e9bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/22.png
// module id = yuYf
// module chunks = 1